<div
  class="flex justify-content-start flex-wrap"
  [class]="panelClass"
  [style]="panelStyle"
>
  <div class="flex-initial">
    <button
      pButton
      pRipple
      class="m-0"
      type="button"
      icon="far fa-hand-pointer"
      (click)="toogleBtnClick($event)"
      [disabled]="disabled"
    ></button>
  </div>
  <div class="flex-1">
    <p-chips
      [(ngModel)]="displayCarTypeStrs"
      [disabled]="true"
      seperator=","
    ></p-chips>
  </div>
</div>
<p-dialog [(visible)]="isOpenModal" header="專車類型選擇" appendTo="body" [modal]="true"
  [draggable]="false" [resizable]="false" [dismissableMask]="true" [style]="{ width: '80%' }">
  <form [formGroup]="form" class="mt-2">
    <div class="field grid" formArrayName="carTypes">
      <div *ngFor="let carType of carTypeOptions; index as i" class="field-block col-4" [formGroupName]="i">
        <div class="field-checkbox mb-0">
          <p-checkbox [binary]="true" [(ngModel)]="carType.isSelected" (onChange)="checkBoxChange($event, i)" [ngModelOptions]="{standalone: true}"></p-checkbox>
          <label>{{ carType.label }}</label>
        </div>
        <div *ngIf="carType.isSelected" class="text-right">
          <p-inputNumber formControlName="count" [(ngModel)]="carType.count" class="ml-2" [inputStyle]="{'width': '3vw', 'height': '4vh'}"></p-inputNumber>
          <div *ngIf="isShowValidationMsg(getFormControl(i, 'count'))">
            <small *ngIf="getFormControl(i, 'count')?.errors?.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="grid mt-2">
      <div class="col text-center">
        <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="confirmBtnClick($event)"></button>
        <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
          (click)="cancelBtnClick($event)"></button>
      </div>
    </div>
  </form>
</p-dialog>
